import styled from 'styled-components';

const AdminTableWrap = styled.div`
  flex: 11;
  background-color: ${props => props.theme.tableBgColor};
  outline: none;

  &.modal-open {
    overflow-y: hidden;
  }
`;

export default AdminTableWrap;
